const Alert = ({message, className = '', type = 'error', children}) => {
  let classes = '';

  switch (type) {
    case 'success':
      classes = 'border-success text-black bg-success/5'
      break
    case 'warning':
      classes = 'border-warning/30 text-font bg-warning/5'
      break
    case 'info':
      classes = 'border-primary/30 text-font bg-primary bg-opacity-5'
      break
    case 'error':
    default:
      classes = 'border-danger text-white bg-danger bg-opacity-5'
  }

  return (<div
    className={`border rounded px-4 py-3 text-sm ${classes} ${className}`}>
    {children || message}
  </div>)
};

export default Alert;
